import { render, staticRenderFns } from "./BaseExport.vue?vue&type=template&id=10d6e518&"
import script from "./BaseExport.vue?vue&type=script&lang=js&"
export * from "./BaseExport.vue?vue&type=script&lang=js&"
import style0 from "./BaseExport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports